module.exports = __webpack_public_path__ + "static/media/ie-university-white.abe69181.svg";